/* ============================================================
   DANG — Lifestyle strip auto-scroll ("film roll")
   The strip drifts sideways on its own so visitors can tell
   there's more to see. Manual scrolling stays fully usable:
   - hovering the strip pauses the drift
   - any manual input (wheel, touch, drag) pauses it, and the
     drift resumes a few seconds after the user lets go
   - the image set is cloned once so the loop wraps seamlessly
   - users with "reduce motion" enabled never see it move
   Speed and on/off live in the theme editor (section settings).
   ============================================================ */
(function () {
  'use strict';

  function initStrip(strip) {
    /* A page with several roll sections includes this script once per
       section, and every copy sees every strip — guard so each strip is
       enhanced exactly once (double-init doubles the clones AND stacks
       drift loops). */
    if (strip.dataset.rollInitialized) return;
    strip.dataset.rollInitialized = 'true';

    if (strip.dataset.autoscroll !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = parseFloat(strip.dataset.autoscrollSpeed) || 60; /* px per second */

    /* Clone the image set once, so when the scroll position passes the end
       of the originals we can snap back by exactly one set-width without a
       visible jump. Clones are decorative — hidden from screen readers. */
    var originals = Array.prototype.slice.call(strip.children);
    originals.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('img').forEach(function (img) { img.alt = ''; });
      strip.appendChild(clone);
    });

    var paused = false;
    var resumeTimer = null;
    var lastTime = null;

    /* While drifting, snap + smooth-behavior must be off or they fight the
       per-frame scrollLeft writes. The class flips them (see CSS). */
    strip.classList.add('dang-lifestyle__strip--drifting');

    function halfWidth() { return strip.scrollWidth / 2; }

    function pause() {
      paused = true;
      strip.classList.remove('dang-lifestyle__strip--drifting');
    }

    function scheduleResume(delayMs) {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
        lastTime = null;
        strip.classList.add('dang-lifestyle__strip--drifting');
      }, delayMs);
    }

    /* Hover: pause while the pointer is over the strip (mouse only —
       touch devices fire pointerenter on tap, handled by touchstart). */
    strip.addEventListener('mouseenter', function () {
      clearTimeout(resumeTimer);
      pause();
    });
    strip.addEventListener('mouseleave', function () { scheduleResume(400); });

    /* Manual input: pause, resume after the user has been idle a moment.
       (No 'scroll' listener — the drift itself fires scroll events every
       frame and telling ours from the user's is racy; these three inputs
       cover every way a person can move the strip.) */
    ['wheel', 'touchstart', 'pointerdown'].forEach(function (evt) {
      strip.addEventListener(evt, function () {
        pause();
        scheduleResume(3000);
      }, { passive: true });
    });

    function tick(now) {
      if (!paused) {
        if (lastTime !== null) {
          var dt = Math.min(now - lastTime, 100) / 1000; /* clamp tab-switch gaps */
          var next = strip.scrollLeft + speed * dt;
          var half = halfWidth();
          if (half > strip.clientWidth && next >= half) next -= half;
          strip.scrollLeft = next;
        }
        lastTime = now;
      } else {
        lastTime = null;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Camera-roll accordion: each titled roll's heading is a toggle button.
     The first titled roll on the page starts open, the rest closed — UNLESS the
     URL names one. The homepage roll cards link to /pages/gallery#roll-<slug>,
     and landing on that link should open that roll rather than dropping the
     visitor at the top of the page with the wrong one showing. Each roll's id is
     set in dang-lifestyle-scroll.liquid as "roll-" + the handleized title. */
  function initAccordion() {
    var rolls = document.querySelectorAll('.dang-lifestyle--roll');
    if (!rolls.length) return;

    var wanted = -1;
    try {
      var hash = decodeURIComponent((window.location.hash || '').slice(1));
      if (hash) {
        rolls.forEach(function (roll, i) {
          if (roll.id === hash) wanted = i;
        });
      }
    } catch (e) {
      /* malformed percent-encoding in the hash — just fall back to the first */
    }

    rolls.forEach(function (roll, i) {
      if (roll.dataset.accordionInitialized) return;
      roll.dataset.accordionInitialized = 'true';
      var btn = roll.querySelector('.dang-lifestyle__roll-toggle');
      if (!btn) return;
      function setOpen(open) {
        roll.classList.toggle('dang-lifestyle--open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      setOpen(wanted === -1 ? i === 0 : i === wanted);
      btn.addEventListener('click', function () {
        setOpen(!roll.classList.contains('dang-lifestyle--open'));
      });
    });

    /* The browser already tried to jump to the anchor while the roll was still
       closed, so the position it landed on is wrong. Re-scroll once it's open. */
    if (wanted > -1) {
      var target = rolls[wanted];
      requestAnimationFrame(function () {
        target.scrollIntoView({ block: 'start' });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.dang-lifestyle__strip').forEach(initStrip);
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
